import React from "react";
import Components from "../../components";

const Success = ({ data, dataSetter }) => {
  return (
    <div>
      <Components.PageHeader
        id="page-header"
        label="Page Header"
        title="Ödeme Başarılı"
        safeArea={data?.system?.safeArea}
        pixelRatio={data?.system?.pixelRatio}
      />
      <Components.Success
        id="success"
        label="Success"
        data={data}
        dataSetter={dataSetter}
      />
    </div>
  );
};

export default Success;
